// extracted by mini-css-extract-plugin
export default {"header-slider":"Header_header-slider__cVdnD","header-slider__img":"Header_header-slider__img__QjriJ"};